import useFetch from '../../../hooks/useFetch';
import Api from '../../../api';

const useDeactivateDevice = ({ onSuccess }) => {
  const { onSubmit: handleDeactivate } = useFetch(
    'device-deactivate',
    Api.DEVICE_DEACTIVATE
  );

  const onDeactivate = (id) => () =>
    handleDeactivate({ method: 'PUT', pathParams: { id }, onSuccess });

  return {
    onDeactivate,
  };
};

export default useDeactivateDevice;
